import { z } from 'zod'
import { oc } from '@orpc/contract'

export const assistantActors = oc
  .route({ method: 'GET', path: '/v2/assistant/actors' })
  .input(z.object({}).optional())
  .output(z.object({ actors: z.array(z.string()) }))
